import { ConsumableLifetimeCycleThemeSizeConfig } from './types';

const medium: ConsumableLifetimeCycleThemeSizeConfig = {
  consumableLifetimeCycle: {},
};

export default medium;
